const hourOnlyRegExp = /^([01]?[0-9]|2[0-4])$/;
const timeRegExp = /^([01]?[0-9]|2[0-4]):?([0-5]?[0-9])$/;

export const validateTimeMinutes = (value: string): boolean => {
  const pad = (s: string) => s.padStart(2, '0');
  if (pad(value).length === 2) {
    return (
      (hourOnlyRegExp.test(value) || timeRegExp.test(value)) &&
      Number(pad(value)) <= 24
    );
  } else {
    return hourOnlyRegExp.test(value) || timeRegExp.test(value);
  }
};

/**
 * 任意の文字列が時間形式に変換できるとき、正式な形式に変換する
 * 例: `201` → `2:01`
 */
export const correctTimeMinutes = (value: string): string => {
  // バリデーションが通らない、または2桁の時24以上の数値は時間として不適切のためそのままにしておく
  if (!validateTimeMinutes(value)) return value;

  const pad = (s: string) => s.padStart(2, '0');
  const time = value.slice(0, 2) === '24' ? value.replace('24', '0') : value;

  if (hourOnlyRegExp.test(time))
    return `${
      time.length === 2 && time.slice(0, 1) === '0' ? time.slice(1, 2) : time
    }:00`;

  const m = time.match(timeRegExp);
  if (!m) return time;
  return `${
    m[1].slice(0, 1) === '0' && m[1].length === 2 ? m[1].slice(1, 2) : m[1]
  }:${pad(m[2] ?? '')}`;
};
